import React from 'react';

function OutlineCard({ icon, title, description }) {
  return (
    <div id="OutlineCard">
      <div className="outline-card-header">
        <div className="icon">
          {icon}
        </div>
      </div>
      <div className="outline-card-body">
        <h5>{title}</h5>
        <p>{description}</p>
      </div>
    </div>
  );
}

export default OutlineCard;